export default "__VITE_ASSET__HfwFR9W5__"